import AddressSummary from './AddressSummary'

export default {
  components: {
    AddressSummary,
  },

  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Co-Applicant/Spouse Information">
      <ui-form-item label="First Name">
        {{ model.coapplicant.firstName }}
      </ui-form-item>

      <ui-form-item label="Middle Name">
        {{ model.coapplicant.middleName }}
      </ui-form-item>

      <ui-form-item label="Last Name">
        {{ model.coapplicant.lastName }}
      </ui-form-item>

      <ui-form-item label="Birth Date">
        {{ model.coapplicant.dateOfBirth }}
      </ui-form-item>

      <ui-form-item label="Social Security Number">
        {{ model.coapplicant.ssn }}
      </ui-form-item>

      <br>
      <ui-form-item label="Drivers License Number">
        {{ model.coapplicant.driversLicense.number }}
      </ui-form-item>

      <ui-form-item label="Issuing State">
        {{ model.coapplicant.driversLicense.state }}
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },
}
